module.exports = __webpack_public_path__ + "img/framenew_box22.a61fd9a3.jpg";